export const CURRENCY = 'EUR'
export const DEFAULT_BRAND = 'AGM VISION'

export function itemIdOf(variant) {
  return variant && variant.id != null ? String(variant.id) : ''
}

export function money(value) {
  const number = Number(value)
  return Number.isFinite(number)
    ? Math.round((number + Number.EPSILON) * 100) / 100
    : 0
}

export function catalogItem(product, variant, quantity, price) {
  return {
    item_id: itemIdOf(variant),
    item_name: variant.name || product.name || '',
    item_brand: product.brand?.name || DEFAULT_BRAND,
    item_variant: variant.name || '',
    price: money(price),
    quantity,
  }
}

export function orderItems(order) {
  return (order.order_variants || [])
    .map(line => {
      const quantity = line.quantity || 1
      return {
        item_id: itemIdOf(line.variant),
        item_name: line.variant?.product?.name || '',
        item_brand: line.variant?.product?.brand?.name || DEFAULT_BRAND,
        item_variant: line.variant?.name || '',
        price: money(line.total_ttc / quantity),
        quantity,
        discount: money((line.offer_discount_ttc || 0) / quantity),
      }
    })
    .filter(item => item.item_id && item.item_name)
}

export function orderDiscount(order) {
  const granted =
    Number(order.total_variants_ttc || 0) +
    Number(order.total_shipping_ttc || 0) +
    Number(order.total_payment_fees_ttc || 0) -
    Number(order.total_ttc || 0)
  return money(Math.max(0, granted))
}

export function purchaseEcommerce(order) {
  const conversion = order.conversion
  return {
    transaction_id: String(order.id),
    value: money(order.total_ttc),
    currency: CURRENCY,
    coupon: conversion?.coupon ?? order.code?.code ?? null,
    discount: conversion
      ? money(conversion.discount_ttc)
      : orderDiscount(order),
    ...(conversion
      ? {
          new_customer: Boolean(conversion.is_new_customer),
          customer_lifetime_value: money(conversion.customer_lifetime_value),
        }
      : {}),
    items: orderItems(order),
  }
}

export function pushEcommerceEvent(dataLayer, event) {
  dataLayer.push({ ecommerce: null })
  dataLayer.push(event)
}
